import { List } from '../objects/list';
import { Error } from '../objects/error';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Preferences } from '../../profile/objects/preferences';
import { RecommendedAccommodation } from '../objects/recommendedAccommodation';
import { Column } from '../objects/column';
import { AccommodationTag } from '../../accommodationTag/objects/accommodationTag';
import { Cms } from '../../cms/objects/cms';
import { ColumnResizePayload } from '../../utils/list/utils/columnResize';

export const ADD_PREFERENCES = 'RECOMMENDED_ACCOMMODATION_ADD_PREFERENCES';
export const DELETE_CUSTOM_PICTURE = 'RECOMMENDED_ACCOMMODATION_DELETE_CUSTOM_PICTURE';
export const MOVE_DOWN_COLUMN = 'RECOMMENDED_ACCOMMODATION_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'RECOMMENDED_ACCOMMODATION_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'RECOMMENDED_ACCOMMODATION_RESET_FILTERS';
export const RESET_RECOMMENDED_ACCOMMODATION = 'RECOMMENDED_ACCOMMODATION_RESET_RECOMMENDED_ACCOMMODATION';
export const SET_EDIT = 'RECOMMENDED_ACCOMMODATION_SET_EDIT';
export const SET_ERRORS = 'RECOMMENDED_ACCOMMODATION_SET_ERRORS';
export const SET_EXPORT_TYPE = 'RECOMMENDED_ACCOMMODATION_SET_EXPORT_TYPE';
export const SET_LIMIT = 'RECOMMENDED_ACCOMMODATION_SET_LIMIT';
export const SET_LIST = 'RECOMMENDED_ACCOMMODATION_SET_LIST';
export const SET_ORDER_BY = 'RECOMMENDED_ACCOMMODATION_SET_ORDER_BY';
export const SET_PAGE = 'RECOMMENDED_ACCOMMODATION_SET_PAGE';
export const SET_PREFERENCES = 'RECOMMENDED_ACCOMMODATION_SET_PREFERENCES';
export const SET_RECOMMENDED_ACCOMMODATION = 'RECOMMENDED_ACCOMMODATION_SET_RECOMMENDED_ACCOMMODATION';
export const SET_RECOMMENDED_ACCOMMODATION_SELECTED = 'RECCOMMDED_ACCOMMODATION_SET_RECOMMENDED_ACCOMMODATION_SELECTED';
export const SET_RUNNING = 'RECOMMENDED_ACCOMMODATION_SET_RUNNING';
export const SET_SEARCH = 'RECOMMENDED_ACCOMMODATION_SET_SEARCH';
export const TOGGLE_COLUMN = 'RECOMMENDED_ACCOMMODATION_TOGGLE_COLUMN';
export const TOGGLE_EXPORT = 'RECOMMENDED_ACCOMMODATION_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'RECOMMENDED_ACCOMMODATION_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'RECOMMENDED_ACCOMMODATION_TOGGLE_FILTERS';
export const TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN = 'RECOMMENDED_ACCOMMODATION_TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN';
export const TOGGLE_PICTURE_ACTIVATED = 'RECOMMENDED_ACCOMMODATION_TOGGLE_PICTURE_ACTIVATED';
export const TOGGLE_REFRESH = 'RECOMMENDED_ACCOMMODATION_TOGGLE_REFRESH';
export const UPDATE_FILTER_CITY = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_CITY';
export const UPDATE_FILTER_COUNTRY = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_COUNTRY';
export const UPDATE_FILTER_IS_ALL_ACCOMMODATION = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_IS_ALL_ACCOMMODATION';
export const UPDATE_FILTER_NAME = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_NAME';
export const UPDATE_FILTER_TAG = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_TAG';
export const UPDATE_FILTER_ALLOWED_CMS = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_ALLOWED_CMS';
export const UPDATE_FILTER_STARS = 'RECOMMENDED_ACCOMMODATION_UPDATE_FILTER_STARS';
export const UPDATE_LIST_ITEM_BLACKLIST = 'RECOMMENDED_ACCOMMODATION_UPDATE_LIST_ITEM_BLACKLIST';
export const UPDATE_LIST_ITEM_FAVORITE = 'RECOMMENDED_ACCOMMODATION_UPDATE_LIST_ITEM_FAVORITE';
export const SET_LIST_ITEM_FAVORITE = 'RECOMMENDED_ACCOMMODATION_SET_LIST_ITEM_FAVORITE';
export const SET_LIST_ITEM_BLACKLIST = 'RECOMMENDED_ACCOMMODATION_SET_LIST_ITEM_BLACKLIST';
export const UPDATE_PICTURE_ORDER = 'RECOMMENDED_ACCOMMODATION_UPDATE_PICTURE_ORDER';
export const UPDATE_REMARK_FAVORITE = 'RECOMMENDED_ACCOMMODATION_UPDATE_REMARK_FAVORITE';
export const SET_COLUMNS = 'USER_SET_COLUMNS';
export const SET_ACCOMMODATION_TAGS = 'RECOMMENDED_ACCOMMODATION_ACCOMMODATION_TAGS';
export const UPDATE_ALLOWED_CMS = 'RECOMMENDED_ACCOMMODATION_UPDATE_ALLOWED_CMS';
export const SET_AUTHORIZE_TO_CMS = 'RECOMMENDED_ACCOMMODATION_SET_AUTHORIZE_TO_CMS';
export const RESIZE_COLUMN = 'RECOMMENDED_ACCOMMODATION_RESIZE_COLUMN';


interface SetAccommodationTagsAction {
    type: typeof SET_ACCOMMODATION_TAGS,
    payload: Record<number, AccommodationTag>
}
interface UpdateAllowedCmsAction {
    type: typeof UPDATE_ALLOWED_CMS,
    payload: Cms[]
}
interface SetAuthorizeToCmsAction {
    type: typeof SET_AUTHORIZE_TO_CMS,
    payload: boolean
}
interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: ColumnResizePayload
}

interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface DeleteCustomPictureAction {
    type: typeof DELETE_CUSTOM_PICTURE,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface ResetRecommendedAccommodationAction {
    type: typeof RESET_RECOMMENDED_ACCOMMODATION
}

interface SetEditAction {
    type: typeof SET_EDIT,
    payload: null | 'NOTE' | 'PICTURES' | 'PICTURES_ORDER' | 'INFO' | 'TAG' | 'ALLOWED_CMS'
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRecommendedAccommodationAction {
    type: typeof SET_RECOMMENDED_ACCOMMODATION,
    payload: RecommendedAccommodation
}

interface SetRecommendedAccommdationSelected {
    type: typeof SET_RECOMMENDED_ACCOMMODATION_SELECTED,
    payload: number[]
}
interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleListComfirmActionIsOpenAction{
    type: typeof TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN,
    payload: boolean
}

interface TogglePictureActivatedAction {
    type: typeof TOGGLE_PICTURE_ACTIVATED,
    payload: number
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCityAction {
    type: typeof UPDATE_FILTER_CITY,
    payload: string
}

interface UpdateFilterCountryAction {
    type: typeof UPDATE_FILTER_COUNTRY,
    payload: null | IataCountry
}

interface UpdateFilterIsAllAccommodaitonAction {
    type: typeof UPDATE_FILTER_IS_ALL_ACCOMMODATION,
    payload: 'blacklist_only' | 'favorite_only' | 'all'
}

interface UpdateFilterNameAction {
    type: typeof UPDATE_FILTER_NAME,
    payload: string
}
interface UpdateFilterTagAction {
    type: typeof UPDATE_FILTER_TAG,
    payload: AccommodationTag[]
}
interface UpdateFilterStarsAction {
    type: typeof UPDATE_FILTER_STARS,
    payload: number[]
}
interface UpdateFilterAllowedCmsAction {
    type: typeof UPDATE_FILTER_ALLOWED_CMS,
    payload: Cms[]
}

interface UpdateListItemBlacklist {
    type: typeof UPDATE_LIST_ITEM_BLACKLIST,
    payload: number
}

interface UpdateListItemFavorite {
    type: typeof UPDATE_LIST_ITEM_FAVORITE,
    payload: number
}

interface SetListItemFavorite {
    type: typeof SET_LIST_ITEM_FAVORITE,
    payload: {
        index: number,
        action: boolean
    }
}

interface setListItemBlacklist {
    type: typeof SET_LIST_ITEM_BLACKLIST,
    payload: {
        index: number,
        action: boolean
    }
}

interface UpdatePictureOrderAction {
    type: typeof UPDATE_PICTURE_ORDER,
    payload: {
        drag_index: number,
        hover_index: number
    }
}

interface UpdateRemarkFavoriteAction {
    type: typeof UPDATE_REMARK_FAVORITE,
    payload: string
}

export type RecommendedAccommodationActionTypes =
    SetAccommodationTagsAction |
    UpdateAllowedCmsAction |
    SetAuthorizeToCmsAction |
    SetColumnsAction |
    ResizeColumnAction |
    AddPreferencesAction |
    DeleteCustomPictureAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    ResetRecommendedAccommodationAction |
    SetEditAction |
    SetRecommendedAccommodationAction |
    SetRecommendedAccommdationSelected |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleListComfirmActionIsOpenAction |
    TogglePictureActivatedAction |
    ToggleRefreshAction |
    UpdateFilterCityAction |
    UpdateFilterCountryAction |
    UpdateFilterIsAllAccommodaitonAction |
    UpdateFilterNameAction |
    UpdateFilterTagAction |
    UpdateFilterAllowedCmsAction |
    UpdateFilterStarsAction |
    UpdateListItemBlacklist |
    UpdateListItemFavorite |
    SetListItemFavorite |
    setListItemBlacklist |
    UpdatePictureOrderAction |
    UpdateRemarkFavoriteAction;